import { mapState } from 'vuex'

export default {
  data() {
    return { currency: 'brl', currencyLocale: 'pt-BR' }
  },
  computed: {
    ...mapState('user', {
      planInfo: 'userPlanInfo',
    }),
    locale() {
      return this.$i18next.resolvedLanguage || 'en'
    },
  },
  methods: {
    setCurrencyConfig() {
      const currency = this.locale === 'pt' ? 'brl' : 'usd'
      if (currency === 'usd') {
        this.currencyLocale = 'en-US'
        return
      } else {
        this.currencyLocale = 'pt-BR'
      }
    },
  },
  created() {
    this.setCurrencyConfig()
    this.currency = this.planInfo?.currency ?? 'blr'
  },
  watch: {
    planInfo: {
      handler(newVal) {
        this.currency = newVal?.currency
      },
      deep: true,
      immediate: true,
    },
    locale: {
      handler() {
        this.setCurrencyConfig()
      },
      immediate: false,
    },
  },
}
